import React from 'react';
import {
  Button,
  Col, DatePicker, Form, FormInstance, Row, Space,
} from 'antd';
import Card from 'antd/es/card/Card';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import GuarantiesFields, { guarantiesFormItems } from './index';

interface GuarantiesAddMoreFieldsProps {
  currentForm: FormInstance;
  disabled?: boolean;
}

function GuarantiesAddMoreFields({ currentForm, disabled }: GuarantiesAddMoreFieldsProps) {
  return (
    <Form.List name="periods">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <Card
              size="small"
              key={key}
              style={{ marginBottom: 16 }}
              title={`Additional section ${name + 1}`}
              extra={!disabled && <MinusCircleOutlined onClick={() => remove(name)} />}
            >
              <Space direction="vertical" style={{ width: '100%' }}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      name={[name, 'startDate']}
                      label="Start date"
                      dependencies={[['periods', name, 'endDate']]}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const endDate = getFieldValue(['periods', name, 'endDate']);

                            if (!value && !endDate) {
                              return Promise.reject(new Error('Please select at least one date'));
                            }

                            if (value && endDate && value.isAfter(endDate)) {
                              return Promise.reject(new Error('Please adjust the dates — ranges should not intersect'));
                            }

                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      name={[name, 'endDate']}
                      label="End date"
                      dependencies={[['periods', name, 'startDate']]}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const startDate = getFieldValue(['periods', name, 'startDate']);

                            if (!value && !startDate) {
                              return Promise.reject(new Error('Please select at least one date'));
                            }

                            if (value && startDate && value.isBefore(startDate)) {
                              return Promise.reject(new Error('Please adjust the dates — ranges should not intersect'));
                            }

                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                </Row>
                <GuarantiesFields id={name} restField={restField} />
                {/* <PriceOverviewFields id={name} restField={restField} /> */}
              </Space>
            </Card>
          ))}

          <Form.Item>
            <Button
              type="dashed"
              onClick={() => {
                add({
                  ...guarantiesFormItems.reduce((acc, { name }) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    acc[name] = currentForm.getFieldValue(name);

                    return acc;
                  }, {}),
                  // isPriceOverviewVisible: currentForm.getFieldValue('isPriceOverviewVisible'),
                  // priceOverview: currentForm.getFieldValue('priceOverview'),
                  // tooltips: currentForm.getFieldValue('tooltips'),
                });
              }}
              block
              icon={<PlusOutlined />}
            >
              Add more
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
}

export default GuarantiesAddMoreFields;
